<div class="grid-container">
	<mat-toolbar style="background-color: transparent">
		<span><a class="title" routerLink="/channels">Canales</a></span>
		<span style="margin-top: 10px;"><mat-icon>chevron_right</mat-icon></span>
		<span>Canal</span>
		<span class="spacer" style="flex: 1 1 auto"></span>
	</mat-toolbar>
	<mat-card>
		<mtx-loader [loading]="loading" type="spinner" color="accent" [hasBackdrop]="true">
			<form autocomplete="off" class="channelForm" [formGroup]="channelForm" (ngSubmit)="saveChannel(cf)" #cf="ngForm" novalidate>
				<div class="channel">
					<mat-form-field appearance="outline">
						<mat-label>Nombre</mat-label>
						<input matInput type="text" formControlName="name" />
					</mat-form-field>
				</div>

				<div style="display: flex; justify-content: flex-end">
					<button mat-raised-button color="primary" type="submit" [disabled]="!channelForm.valid">Guardar</button>
				</div>
			</form>
		</mtx-loader>
	</mat-card>
</div>
